export default "__VITE_ASSET__BUq8DG32__"